;(function() {
  'use strict'

  angular.module('core.contentHeader', [])
})()
